export default "<div class=\"vl-filter-list\">\n  <ng-content></ng-content>\n</div>\n";